import { render } from "./GlobalNumber.vue?vue&type=template&id=2eea9007"
import script from "./GlobalNumber.vue?vue&type=script&lang=js"
export * from "./GlobalNumber.vue?vue&type=script&lang=js"

import "./GlobalNumber.vue?vue&type=style&index=0&id=2eea9007&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__